"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSelectAllGuard = exports.resetDocumentContent = exports.isFullDocSelected = exports.docPlainTextLength = void 0;
const slate_1 = require("slate");
/** Sum of plain-text character counts across every `Text` node in the doc. */
const docPlainTextLength = (editor) => {
    let total = 0;
    for (const [node] of slate_1.Editor.nodes(editor, { at: [], match: slate_1.Text.isText })) {
        total += node.text.length;
    }
    return total;
};
exports.docPlainTextLength = docPlainTextLength;
/** Returns `true` when the selection is an expanded range that covers the
 * entire user-visible document. */
const isFullDocSelected = (editor) => {
    const { selection } = editor;
    if (!selection || slate_1.Range.isCollapsed(selection))
        return false;
    const children = editor.children;
    if (!children.length)
        return false;
    const firstIdx = 0;
    const lastIdx = children.length - 1;
    if (lastIdx < firstIdx)
        return false;
    let docStart;
    let docEnd;
    try {
        docStart = slate_1.Editor.start(editor, [firstIdx]);
        docEnd = slate_1.Editor.end(editor, [lastIdx]);
    }
    catch {
        return false;
    }
    const [selStart, selEnd] = slate_1.Range.edges(selection);
    return (slate_1.Path.equals(selStart.path, docStart.path) &&
        selStart.offset === docStart.offset &&
        slate_1.Path.equals(selEnd.path, docEnd.path) &&
        selEnd.offset === docEnd.offset);
};
exports.isFullDocSelected = isFullDocSelected;
const resetDocumentContent = (editor, text = '') => {
    slate_1.Editor.withoutNormalizing(editor, () => {
        const firstIdx = 0;
        for (let i = editor.children.length - 1; i >= firstIdx; i--) {
            slate_1.Transforms.removeNodes(editor, { at: [i] });
        }
        const paragraph = { type: 'p', children: [{ text }] };
        slate_1.Transforms.insertNodes(editor, paragraph, { at: [firstIdx] });
        const caret = text ? slate_1.Editor.end(editor, [firstIdx]) : slate_1.Editor.start(editor, [firstIdx]);
        slate_1.Transforms.select(editor, caret);
    });
};
exports.resetDocumentContent = resetDocumentContent;
const withSelectAllGuard = (editor, hooks) => {
    const { deleteFragment, insertText, insertFragment } = editor;
    editor.deleteFragment = (direction) => {
        if ((0, exports.isFullDocSelected)(editor)) {
            if (hooks.onDelete?.())
                return;
            (0, exports.resetDocumentContent)(editor);
            return;
        }
        deleteFragment(direction);
    };
    editor.insertText = (text) => {
        if (text && (0, exports.isFullDocSelected)(editor)) {
            if (hooks.onReplaceWithText?.(text))
                return;
            (0, exports.resetDocumentContent)(editor, text);
            return;
        }
        insertText(text);
    };
    editor.insertFragment = (fragment) => {
        if ((0, exports.isFullDocSelected)(editor)) {
            if (hooks.onReplaceWithFragment?.(fragment))
                return;
            (0, exports.resetDocumentContent)(editor);
        }
        insertFragment(fragment);
    };
    return editor;
};
exports.withSelectAllGuard = withSelectAllGuard;
